import React from 'react';
import styled from 'styled-components';
import Container from 'components/_utility/Container';
import { minBp } from 'src/lib/theme';

export const Wrap = styled(Container)`
  ${({ fluid }) => `
    width: 100%;
    flex: 1;
    padding: 10px 0;

    @media ${minBp('tabletLarge')} {
      flex: 1;
      padding: 0;

      ${
        fluid
          ? `
        max-width: 100%;
        padding-left: 100px;

        @media ${minBp('desktop')} {
          padding-left: 100px;
        }
      `
          : ``
      }
    }
  `}
`;

export const Option = styled.div`
  appearance: none;
  display: inline-flex;
  border-radius: 4px;
  background-color: #2a2a2a;
  color: white;
  border: 0;
  font-size: 12px;
  padding: 2px 6px 0 6px;
  line-height: 1;
  height: 24px;
  align-items: center;
  justify-content: center;
  margin: 0 6px 6px 0;
  cursor: pointer;

  @media ${minBp('tabletLarge')} {
    height: 32px;
    font-size: 16px;
  }
`;

export const Close = styled.button`
  appearance: none;
  margin-right: 4px;
  background: transparent;
  width: 16px;
  height: 16px;
  border: 0;
  padding: 0;
  pointer-events: none;
  font-size: 12px;

  svg {
    height: 16px;
    width: 16px;
    vertical-align: middle;
    position: relative;
    bottom: 1px;

    path {
      fill: white;
    }
  }
`;
